// https://docs.aws.amazon.com/silk/latest/developerguide/user-agent.html
// https://docs.aws.amazon.com/silk/latest/developerguide/screen-size.html
export const FIRE_TABLET_GENERATIONS = {
  KFTUWI: { gen: 13, description: 'Fire HD 10 (13th Gen)' },
  KFTUWA: { gen: 13, description: 'Fire HD 10 (13th Gen)' },
  KFSNWI: { gen: 13, description: 'Fire Max 11 (13th Gen)' },
  KFSNWA: { gen: 13, description: 'Fire Max 11 (13th Gen)' },

  KFRAWI: { gen: 12, description: 'Fire HD 8, 8+ (12th Gen)' },
  KFRAWA: { gen: 12, description: 'Fire HD 8, 8+ (12th Gen)' },
  KFQUWI: { gen: 12, description: 'Fire 7 (12th Gen)' },

  KFTRWI: { gen: 11, description: 'Fire HD 10, 10+ (11th Gen)' },
  KFTRWA: { gen: 11, description: 'Fire HD 10, 10+ (11th Gen)' },

  KFONWI: { gen: 10, description: 'Fire HD 8, 8+ (10th Gen)' },

  KFMAWI: { gen: 9, description: 'Fire HD 10 (9th Gen)' },
  KFMUWI: { gen: 9, description: 'Fire 7 (9th Gen)' },

  KFKAWI: { gen: 8, description: 'Fire HD 8 (8th Gen)' },

  KFSUWI: { gen: 7, description: 'Fire 7 (7th Gen)' },
  KFAUWI: { gen: 7, description: 'Fire HD 10 (7th Gen)' },
  KFDOWI: { gen: 7, description: 'Fire HD 8 (7th Gen)' },

  KFGIWI: { gen: 6, description: 'Fire HD 8 (6th Gen)' },

  KFTBWI: { gen: 5, description: 'Fire HD 10 (5th Gen)' },
  KFMEWI: { gen: 5, description: 'Fire HD 8 (5th Gen)' },
  KFFOWI: { gen: 5, description: 'Fire (5th Gen)' },

  KFSAWI: { gen: 4, description: 'Fire HDX 8.9 (4th Gen)' },
  KFSAWA: { gen: 4, description: 'Fire HDX 8.9 LTE (4th Gen)' },
  KFASWI: { gen: 4, description: 'Fire HD 7 (4th Gen)' },
  KFARWI: { gen: 4, description: 'Fire HD 6 (4th Gen)' },

  KFAPWI: { gen: 3, description: 'Fire HDX 8.9 (3rd Gen)' },
  KFAPWA: { gen: 3, description: 'Fire HDX 8.9 LTE (3rd Gen)' },
  KFTHWI: { gen: 3, description: 'Fire HDX 7 (3rd Gen)' },
  KFTHWA: { gen: 3, description: 'Fire HDX 7 LTE (3rd Gen)' },
  KFSOWI: { gen: 3, description: 'Fire HD 7 (3rd Gen)' },
};

const FIRE_TABLET_MODEL = /\b(KF[A-Z0-9]{2,5}W[IA]|KFTT|KFOT)\b/i;
const FIRE_TABLET = /\b(Kindle Fire|Kindle|Silk)\b/i;
const SAMSUNG_TABLET = /\b(SM-T\d{3,4}[A-Z]?|SM-X\d{3,4}[A-Z]?|GT-P\d{4}|SCH-I800|SGH-T849|SHW-M\d{3})\b/i;
const ANDROID_TABLET = /Tablet|Android.*Pixel C|PlayBook|Hudl HT7S3|Hudl 2|Nexus\s+(7|9|10)|\bTB[-_][A-Z0-9]+/i;

export const getFireTablet = (ua = '') => {
  const model = ua.match(FIRE_TABLET_MODEL);
  if (model) {
    const id = model[1].toUpperCase();
    return FIRE_TABLET_GENERATIONS[id] || { gen: 0, description: 'Fire tablet' };
  }

  return FIRE_TABLET.test(ua) ? { gen: 0, description: 'Fire tablet' } : null;
};

export const isTabletUserAgent = (ua = '') => {
  return !!(getFireTablet(ua) || SAMSUNG_TABLET.test(ua) || ANDROID_TABLET.test(ua));
};
